/* PlanSelector.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _28 = "._syazwdcn{color:var(--ds-icon,#44546f)}";
const _27 = "._4cvr1h6o{align-items:center}";
const _26 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _25 = "._18u01wug{margin-left:auto}";
const _24 = "._otyr1wug{margin-bottom:auto}";
const _23 = "._2hwx1wug{margin-right:auto}";
const _22 = "._19pk1wug{margin-top:auto}";
const _21 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _20 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _19 = "._k48p1pd9{font-weight:var(--ds-font-weight-semibold,600)}";
const _18 = "._80om13gf{cursor:not-allowed}";
const _17 = "._bfhksyzs{background-color:var(--ds-background-disabled,#091e4208)}";
const _16 = "._19it1hgh{border:var(--_18fhuuy)}";
const _15 = "._19it14x9{border:var(--_f9up2s)}";
const _14 = "._4cvr1y6m{align-items:flex-start}";
const _13 = "._2lx21bp4{flex-direction:column}";
const _12 = "._p12f7ivc{max-width:344px}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._19itpp12{border:var(--_18x9sjc)}";
const _9 = "._2rko1y44{border-radius:4px}";
const _8 = "._zulp1b66{gap:var(--ds-space-050,4px)}";
const _7 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _6 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
// eslint-disable-next-line import/no-extraneous-dependencies
import Lozenge from '@atlaskit/lozenge';
import { media, Stack } from '@atlaskit/primitives';
import { Radio } from '@atlaskit/radio';
import Tooltip from '@atlaskit/tooltip';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BodySmall, ExternalLink, H6, Link } from '@atlassian/mpac-primitives';
import { Source } from '@atlassian/mpac-types';
import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
import { TooltipDialog } from '@atlassian/mpac-ui';
import { editionConstants, getEditionDescription, useSource } from '@atlassian/mpac-utils';
import capitalize from 'lodash/capitalize';
import { TEST_IDS } from '../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@media not all and (min-width:48rem){._1gde1bp4{flex-direction:column}._ag851y6m{align-items:flex-start}}";
const _4 = "._1wpz1fhb{align-self:stretch}";
const _3 = "._4cvr1fhb{align-items:stretch}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const {
  EDITIONS_TYPE,
  EDITIONS_SUBTITLE_CUSTOMERS_FOR_FREE_EDITION_VIEW,
  EDITIONS_SUBTITLE_CUSTOMERS,
  ADVANCED_EDITION_BANNER_TEXT
} = editionConstants;
const Flex = null;
const FlexColumn = null;
const linkStyles = null;
const planSelectorContainer = null;
const boldTextStyles = null;
const tooltipIconContainerStyles = null;
const radioCardStyles = null;
const radioCardDisabledStyles = null;
const radioCardSelectedStyles = null;
const planRadioCardSubtextStyles = null;
const PlanSelectorBox = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi _1e0c1txw _4cvr1fhb _1wpz1fhb _1gde1bp4 _ag851y6m", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  PlanSelectorBox.displayName = 'PlanSelectorBox';
}
const advancedEditionLozengeStyles = null;
const advancedEditionLozenge = /*#__PURE__*/_jsxs(CC, {
  children: [/*#__PURE__*/_jsx(CS, {
    children: [_6]
  }), /*#__PURE__*/_jsx("span", {
    className: ax(["_18u0u2gc"]),
    children: /*#__PURE__*/_jsx(Lozenge, {
      appearance: "success",
      children: ADVANCED_EDITION_BANNER_TEXT
    })
  })]
});
const RadioCardContainer = _ref2 => {
  let {
    planType,
    isSelected,
    onChange,
    isDisabled,
    isFreeAppsEditionsViewEnabled
  } = _ref2;
  const {
    enableAdvancedExperimentOnPricingTab
  } = useStatsig();
  const handleClickRadio = () => {
    if (!isSelected && !isDisabled) {
      onChange({
        label: capitalize(planType),
        value: planType
      });
    }
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _2, _11, _12, _13, _14, _15, _16, _17, _18]
    }), /*#__PURE__*/_jsx("div", {
      onClick: handleClickRadio,
      onKeyDown: e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClickRadio();
        }
      },
      tabIndex: 0,
      role: "radio",
      "aria-checked": isSelected,
      "aria-label": "Select ".concat(EDITIONS_TYPE[planType], " edition"),
      "data-testid": TEST_IDS.TWO_CLICK_PLAN_SELECTOR_RADIO + planType.toLowerCase(),
      className: ax(["_1yt4pxbi _zulp1b66 _2rko1y44 _19itpp12 _1e0c1txw _1bsb1osq _p12f7ivc _2lx21bp4 _4cvr1y6m", isSelected && "_19it14x9", isDisabled && "_19it1hgh _bfhksyzs _80om13gf"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)")),
        "--_f9up2s": ix("1px solid ".concat("var(--ds-border-selected, #0C66E4)")),
        "--_18fhuuy": ix("1px solid ".concat("var(--ds-border-disabled, #091E420F)"))
      },
      children: /*#__PURE__*/_jsx(Radio, {
        label: /*#__PURE__*/_jsxs(Stack, {
          space: "space.050",
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_19]
            }), /*#__PURE__*/_jsxs(BodySmall, {
              className: ax(["_k48p1pd9"]),
              children: [capitalize(planType), planType === MarketplaceStoreEditionType.Advanced && enableAdvancedExperimentOnPricingTab() && advancedEditionLozenge]
            })]
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_20]
            }), /*#__PURE__*/_jsx(BodySmall, {
              "data-testid": TEST_IDS.TWO_CLICK_PLAN_SELECTOR_SUBTEXT + planType.toLowerCase(),
              className: ax(["_18s8ze3t"]),
              children: isFreeAppsEditionsViewEnabled ? EDITIONS_SUBTITLE_CUSTOMERS_FOR_FREE_EDITION_VIEW[planType] : EDITIONS_SUBTITLE_CUSTOMERS[planType]
            })]
          })]
        }),
        isChecked: isSelected,
        isDisabled: isDisabled
      })
    })]
  });
};
const PlanSelectorTooltipContent = (appPricingDetailsLink, editionDescription) => {
  const source = useSource();
  const ExplorePricingPlansLink = source === Source.MPAC ? Link : ExternalLink;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _13]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1e0c1txw _2lx21bp4"]),
      children: [/*#__PURE__*/_jsx("span", {
        children: editionDescription
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_21]
        }), /*#__PURE__*/_jsx(ExplorePricingPlansLink, {
          size: "small",
          href: appPricingDetailsLink,
          className: ax(["_19pk1b66"]),
          children: "Explore app editions"
        })]
      })]
    })]
  });
};
const isRadioCardDisabled = (isFreeAppsEditionsViewEnabled, edition, installedEdition) => {
  if (!isFreeAppsEditionsViewEnabled) {
    return false;
  }
  if (edition === installedEdition) {
    return true;
  }
  return false;
};
const TWO_CLICK_PLAN_SELECTOR_HEADING_ID = 'two-click-plan-selector-heading-id';
export const PlanSelector = props => {
  const {
    enableFreeAppEditionsView
  } = useStatsig();
  const editionDescription = getEditionDescription(props.editions.map(edition => edition.value), enableFreeAppEditionsView());
  const TooltipContent = PlanSelectorTooltipContent(props.appPricingDetailsLink, editionDescription);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _24, _25, _26, _2, _13, _11]
    }), /*#__PURE__*/_jsxs("div", {
      role: "radiogroup",
      "aria-labelledby": TWO_CLICK_PLAN_SELECTOR_HEADING_ID,
      className: ax(["_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulputpp _1e0c1txw _2lx21bp4 _1bsb1osq"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_2, _27]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_1e0c1txw _4cvr1h6o"]),
          children: [/*#__PURE__*/_jsx(H6, {
            as: "h2",
            "data-testid": TEST_IDS.TWO_CLICK_PLAN_SELECTOR_HEADING,
            id: TWO_CLICK_PLAN_SELECTOR_HEADING_ID,
            children: enableFreeAppEditionsView() ? 'Select a plan' : 'Select an edition'
          }), /*#__PURE__*/_jsx(Tooltip, {
            component: TooltipDialog,
            position: "bottom-start",
            content: TooltipContent,
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_2, _28]
              }), /*#__PURE__*/_jsx("div", {
                "aria-label": enableFreeAppEditionsView() ? 'Select a plan' : 'Select an edition',
                tabIndex: 0,
                role: "button",
                className: ax(["_1e0c1txw _syazwdcn"]),
                children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                  label: "Learn more about app editions",
                  size: "medium",
                  testId: TEST_IDS.PLAN_SELECTOR_TOOLTIP
                })
              })]
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(PlanSelectorBox, {
        children: props.editions.map(edition => /*#__PURE__*/_jsx(RadioCardContainer, {
          planType: edition.value,
          isSelected: props.selectedPlanType.value === edition.value,
          onChange: props.setSelectedPlanType,
          isDisabled: isRadioCardDisabled(enableFreeAppEditionsView(), edition.value, props.editionInstalledOnSelectedSite),
          isFreeAppsEditionsViewEnabled: enableFreeAppEditionsView()
        }, edition.value))
      })]
    })]
  });
};